import client from '../client';
import * as commodityQueries from "../queries/commodity";
import * as commodityMutations from "../mutations/commodity";


export function getCommodities(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: commodityQueries.all,
    })
    .then(success)
    .catch(error);
}


export function get(success, error, id, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { id: id },
        fetchPolicy: fetchPolicy,
        query: commodityQueries.get,
    })
        .then(success)
        .catch(error);
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, commodity: data },
        mutation: commodityMutations.edit,
    })
    .then(success)
    .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { commodity: data },
        mutation: commodityMutations.add,
    })
    .then(success)
    .catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/commodity.js